import {createStyledAnimation} from '../create-styled-animation';
import {fadeFlowBuilder} from '../fade/fade';
import {scaleFlowBuilder} from '../scale/scale';
import {PropertyFlowDescription} from '../style-animation';
import {Duration} from '../types';

export function scaleFadeFlowBuilder(duration: Duration): PropertyFlowDescription[] {
	const fadeFlow = fadeFlowBuilder(duration);
	const scaleFlow = scaleFlowBuilder(duration);
	return fadeFlow.concat(scaleFlow);
}

export const ScaleFade = createStyledAnimation('ScaleFade', scaleFadeFlowBuilder);
